module.exports = __webpack_public_path__ + "img/61117f1.png";